import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';
import { FeatureDecisionContext } from '../../shared/contexts/FeatureDecisionContext';
import mode from '../../shared/helpers/Mode';
import Item from '../helpers/Item';

const StepAbilityContext = createContext({
  can: {
    step: {
      backwards: false,
    },
  },
});

const StepAbilityProvider = ({ children, previous, steps }) => {
  const { shouldUseKioskEnhancements, shouldUseKioskEnhancementsRelease } =
    useContext(FeatureDecisionContext);

  const previousStep = steps.find(
    (step) => step.id === Item.get(previous, 'id'),
  );

  let canStepBackwards = !Item.get(previousStep, 'locked', false);

  const useNewKiosk = shouldUseKioskEnhancementsRelease || mode.useNewKiosk();
  const isWalkIn = mode.isWalkIn();
  if (shouldUseKioskEnhancements && useNewKiosk && isWalkIn && !previousStep) {
    canStepBackwards = !!previousStep;
  }

  const abilities = {
    can: {
      step: {
        backwards: canStepBackwards,
      },
    },
  };

  return (
    <StepAbilityContext.Provider value={abilities}>
      {children}
    </StepAbilityContext.Provider>
  );
};

StepAbilityProvider.propTypes = {
  children: PropTypes.element.isRequired,
  previous: PropTypes.shape({
    id: PropTypes.string,
  }),
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      locked: PropTypes.bool,
    }),
  ).isRequired,
};

StepAbilityProvider.defaultProps = {
  previous: undefined,
};

export { StepAbilityContext, StepAbilityProvider };
